import React, { Component } from "react";
import AgentHighlightsItem from '../agent/AgentHighlightsItem.js';

export default class AgentHighlights extends Component {
	
	render () {
		
		let projects = this.props.projects;
				
		if (projects) {
									
		    return (
			    
			    <>
					{projects.map((project,i) =>
						{		    			
							return (
								<AgentHighlightsItem item={project} key={i}></AgentHighlightsItem>
							)
						}
					)}
			    </>
			    
			)
			
		} else {
			
			return null;
		
		}
	}
}
